module.exports = __webpack_public_path__ + "static/media/2.6ca86c71.png";